<template>
  <div class="site_lease">
    <van-sticky>
      <van-nav-bar right-text="取消" title="订单编辑" left-arrow @click-left="goback()" @click-right="goback()" />
    </van-sticky>
    <CardBuilding :detailData="detailData.siteVo"></CardBuilding>
    <!-- 表单 -->
    <van-form label-width="100" class="lease_form">
      <van-cell-group>
        <van-field input-align="right" :value="detailData.orderNumber" label="订单号" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detailData.paymentNumber" label="支付编号" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detailData.payablePrice" label="订单价格" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detailData.status_name" label="订单状态" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detailData.paymentTime" label="支付时间" placeholder="请输入" readonly />
        <div class="lease_title">签约主体信息</div>
        <van-field input-align="right" v-model="detailData.contactName" label="姓名" placeholder="请输入" />
        <van-field input-align="right" v-model="detailData.user_telephone" label="手机号" placeholder="请输入" />
        <van-field input-align="right" v-model="detailData.intermediary_company" label="中介公司名" placeholder="请输入" />
        <van-field input-align="right" v-model="detailData.company" label="预注册公司名称" placeholder="请输入" />
        <div class="form_feature">
          <div class="fs14">场地用途</div>
          <div class="feature_list">
            <!-- <van-button
              color="#0CADFC"
              v-for="items in detailData.siteUse_name"
              :key="items"
              type="info"
              >{{ items }}</van-button
            > -->
            <van-button native-type="button" :color="item.isCheck ? '#0CADFC' : '#DFDDDD'" v-for="(item, index) in siteUseList" :key="item.itemId" @click="changeSiteOpentions(index)">{{
              item.itemText
              }}</van-button>
          </div>
        </div>
        <div class="form_feature">
          <div class="fs14">请选择租赁时长：</div>
          <div class="feature_list">
            <!-- <van-button
              color="#0CADFC"
              v-for="items in detailData.leaseDuration_name"
              :key="items"
              type="info"
              >{{ items }}</van-button> -->
            <van-button native-type="button" :color="item1.isCheck ? '#0CADFC' : '#DFDDDD'" v-for="(item1, index1) in leaseDurationList" :key="item1.itemId" @click="changeLeaseDurationList(index1)">
              {{ item1.itemText }}</van-button>
          </div>
        </div>
        <div class="lease_mark">备注:</div>
        <van-field class="lease_mark_area" v-model="detailData.remark" rows="2" type="textarea" placeholder="请检单描述你的需求" show-word-limit :autosize="{ maxHeight: 400, minHeight: 200 }" />
        <div class="form_feature">
          <div class="fs14 font-weightbold">增值服务（以下服务不参与营销）</div>
          <div class="feature_server" v-for="(itemss, indexss) in extra" :key="itemss">
            <div>{{ itemss.name }}:</div>
            <div class="server_btn">
              <van-button native-type="button" @click="changeExtra(indexss)" :color="itemss.isCheck ? '#0CADFC' : ''">
                不需要</van-button>
              <van-button native-type="button" @click="changeExtra(indexss)" :color="itemss.isCheck ? '' : '#0CADFC'">需要
              </van-button>
            </div>
          </div>
        </div>
        <div class="lease_title">补录资料信息</div>
        <div class="contract_data">
          <div class="data_idcard">
            <div>身份证<span style="color:red;font-size: 13px;"> * </span></div>
            <!-- <div class="idcard_img">
              <div class="img_item" @click="showImage(detailData.idCard_front)">
                <van-image width="100%" fit="fill" :src="detailData.idCard_front" />
                <div>正面</div>
              </div>
              <div class="img_item" @click="showImage(detailData.idCard_back)">
                <van-image width="100%" fit="fill" :src="detailData.idCard_back" />
                <div>反面</div>
              </div>
            </div> -->
            <van-field input-align="center" readonly class="data_idcard" :rules="[{ required: true, message: '请上传身份证图片' }]">
              <template #input>
                <div class="idcard_img" style="width:100%">
                  <van-uploader class="img_idcard" :max-count="1" v-model="uploader1" :after-read="afterRead1" fit="contain" :max-size="100000*1024">
                    <van-icon name="plus" size="30" color="#898989" />
                    <div>上传正面照片</div>
                  </van-uploader>
                  <van-uploader class="img_idcard" fit="contain" :max-count="1" v-model="uploader2" :after-read="afterRead2" :max-size="100000*1024">
                    <van-icon name="plus" size="30" color="#898989" />
                    <div>上传反面照片</div>
                  </van-uploader>
                </div>
              </template>
            </van-field>
          </div>
          <van-form label-width="140">
            <van-cell-group>
              <van-field input-align="right" v-model="detailData.idCard" label="身份证号码" placeholder="请输入" is-link />
              <!-- <div class="data_idcard">
                <div class="m-b20">营业执照<span style="color:red;font-size: 13px;">（*点击可放大预览）</span></div>
                <van-image @click="showImage(detailData.businessLicense)" width="100%" fit="fill" :src="detailData.businessLicense" />
              </div> -->
              <div class="data_idcard" style="padding:0px 20px;">
                <div>营业执照上传<span style="color:red;font-size: 13px;"> * </span></div>
              </div>
              <van-field input-align="center" readonly class="data_idcard" v-model="detailData.businessLicense_fileId" :rules="[{ required: true, message: '请上传营业执照' }]">
                <template #input>
                  <div class="idcard_img" style="width:100%">
                    <van-uploader fit="fill" class="img_license" :max-count="1" v-model="uploader3" :after-read="afterRead3" :max-size="100000*1024">
                      <van-icon name="plus" size="40" color="#898989" />
                      <div>上传营业执照照片</div>
                    </van-uploader>
                  </div>
                </template>
              </van-field>
              <van-field input-align="right" v-model="detailData.unifiedSocialCreditCode" label="统一社会信用代码" placeholder="请输入" is-link />
              <van-field input-align="right" v-model="detailData.company_official" label="公司名称" placeholder="请输入" is-link />
              <van-field input-align="right" v-model="detailData.company_legalPerson" label="法人姓名" placeholder="请输入" is-link />
              <van-field input-align="right" v-model="detailData.company_address" label="地址" placeholder="请输入" is-link />
              <!-- <div class="data_idcard">
                <div class="m-b20">合同文件</div>
                <van-swipe class="my-swipe" :autoplay="1000" indicator-color="black">
                  <van-swipe-item>
                    <van-image v-for="items in detailData.contractImageList" :key="items" width="100%" fit="fill" :src="items.url" />
                  </van-swipe-item>
                </van-swipe>
              </div>
              <van-field input-align="right" v-model="detailData.contractSignTime" label="签约日期" placeholder="请输入" is-link />
              <van-field input-align="right" v-model="detailData.contractExpirationTime" label="到期日期" placeholder="请输入" is-link /> -->
            </van-cell-group>
          </van-form>
        </div>
      </van-cell-group>
    </van-form>
    <van-button style="padding: 20px;margin: 20px;width: 80%;" color="#0CADFC" type="info" @click="submitEdit()">保存订单</van-button>
    <div @click="isShowImage = false" v-if="isShowImage" style="position:fixed;top:0px;left:0px;width: 100%;height: 100%;background: rgba(0,0,0,0.5);z-index:10">
      <van-image @click="isShowImage = false" width="100%" :src="targetImage" height="100%" fit="scale-down" />
    </div>
  </div>
</template>
<script>
import CardBuilding from "../home/components/CardBuilding";
import {
  Button,
  NavBar,
  Icon,
  Sticky,
  Image,
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Tag,
  Swipe,
  SwipeItem,
  Uploader,
  Dialog,
} from "vant";
import storage from "@/utils/storage";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Uploader.name]: Uploader,
    CardBuilding,
  },
  data() {
    return {
      isShowImage: false,
      targetImage: '',
      detailData: [],
      siteUseList: [],
      leaseDurationList: [],
      extra: [
        { name: "工商注册", isCheck: true, value: 'else_registered' },
        { name: "刻章服务", isCheck: true, value: 'else_seal' },
        { name: "银行开户", isCheck: true, value: 'else_bankAccount' },
        { name: "税局登记", isCheck: true, value: 'else_taxBureauRegistration' },
        { name: "年审服务", isCheck: true, value: 'else_annualAudit' },
        { name: "开户预约", isCheck: true, value: 'else_accountOpeningAppointment' },
        { name: "税局上门预约", isCheck: true, value: 'else_taxBureauDoorToDoorAppointment'},
      ],
      //身份证正面
      uploader1: [{ url: "" }],
      //身份证反面
      uploader2: [{ url: "" }],
      //营业执照
      uploader3: [{ url: "" }],
    };
  },

  created() {
    //订单-查看
    this.orderInfoDetail(this.$route.query.id);
  },

  methods: {

    showImage(targetUrl) {
      this.isShowImage = true
      this.targetImage = targetUrl
    },

    //订单-查看
    orderInfoDetail(id) {
      var that = this;
      that.$api
        .orderInfoDetailAPI({ id: id })
        .then(function(res) {
          if (res.data.code === 200) {
            res.data.data.siteUse_name = res.data.data.siteUse_name.split(",");
            res.data.data.leaseDuration_name =
              res.data.data.leaseDuration_name.split(",");
            that.detailData = res.data.data;
            that.uploader1[0].url = that.detailData.idCard_front ? that.detailData.idCard_front : "";
            that.uploader2[0].url = that.detailData.idCard_back ? that.detailData.idCard_back : "";
            that.uploader3[0].url = that.detailData.businessLicense ? that.detailData.businessLicense : "";
            if(that.uploader1[0].url == ""){
                that.uploader1 = [];
              }
              if(that.uploader2[0].url == ""){
                that.uploader2 = [];
              }
              if(that.uploader3[0].url == ""){
                that.uploader3 = [];
              }
            //处理增值服务
            that.extra.forEach(item => {
               item.isCheck = res.data.data[item.value] == '0' ? true:false;
            })
            that.siteUserH5Detail(res.data.data.siteVo.id)
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    onsubmit() {
      this.$router.go(-1);
    },

    //选中场地特色
    changeSiteOpentions(index) {
      let that = this
      that.siteUseList.forEach((element, item) => {
        if (index === item) {
          element.isCheck = true;
          that.detailData.siteUse_name = item.name;
          that.detailData.siteUse = item.itemId;
        } else {
          element.isCheck = false;
        }
      });
      that.calcOrderTotalPrice();
    },

    //选中的租赁时长
    changeLeaseDurationList(index) {
      let that = this
      that.leaseDurationList.forEach((element, item) => {
        if (index === item) {
          element.isCheck = true;
          that.detailData.leaseDuration_name = item.name;
          that.detailData.leaseDuration = item.itemId;
        } else {
          element.isCheck = false;
        }
      });
      that.calcOrderTotalPrice();
    },

    //场地中心-查看
    siteUserH5Detail(id) {
      var that = this;
      that.$api
        .orderInfoUserH5AddAPI({ site_id: id })
        .then(function(res) {
          if (res.data.code === 200) {
            //场地特色
            var siteUseList = res.data.data.siteUseList;
            if (siteUseList.length > 0) {
              siteUseList.forEach((element, index) => {
                element.isCheck = false;
                if (element.itemText == that.detailData.siteUse_name) {
                  element.isCheck = true;
                }
              });
            }
            that.siteUseList = siteUseList
            //租赁时长
            var leaseDurationList = res.data.data.leaseDurationList;;
            if (leaseDurationList.length > 0) {
              leaseDurationList.forEach((element, index) => {
                element.isCheck = false;
                if (element.itemText == that.detailData.leaseDuration_name) {
                  element.isCheck = true;
                }
              });
            }
            that.leaseDurationList = leaseDurationList;
          }
        })
        .catch(function(err) {
          console.log("error", err);
        });
    },

    changeExtra(index) {
      let that = this;
      that.extra[index].isCheck = !that.extra[index].isCheck;
      switch (index) {
        case 0:
          that.detail.else_registered = that.extra[index].isCheck ? 0 : 1;
          //订单-计算应付金额
          that.calcOrderTotalPrice();
          break;
        case 1:
          that.detail.else_seal = that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        case 2:
          that.detail.else_bankAccount = that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        case 3:
          that.detail.else_taxBureauRegistration = that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        case 4:
          that.detail.else_annualAudit = that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        case 5:
          that.detail.else_accountOpeningAppointment =
            that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        default:
          that.detail.else_taxBureauDoorToDoorAppointment =
            that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
      }
    },

    //订单-计算应付金额
    calcOrderTotalPrice() {
      return false;
      var that = this;
      that.$api
        .calcOrderTotalPriceAPI(that.params)
        .then(function(res) {
          if (res.data.code === 200) {
            that.detailData.totalPrice = res.data.data;
          }
        })
        .catch(function(err) {
          console.log("error", err);
        });
    },

    afterRead1(files) {
      this.uploadSingleFileApi(files, 1);
    },

    afterRead2(files) {
      this.uploadSingleFileApi(files, 2);
    },

    afterRead3(files) {
      this.uploadSingleFileApi(files, 3);
    },

    // 上传附件
    uploadSingleFileApi(files, type) {
      var that = this;
      that.$Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      const fromdata = new FormData();
      fromdata.append("uploadfile", files.file);
      that.$axios
        .post(
          process.env.API_ROOT + "tgy/mobile/attachment/uploadSingleFile",
          fromdata, {
            headers: {
              enctype: "multipart/form-data",
              Authorization: storage.getUserInfo(),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "上传成功",
              onClose() {
                if (type === 1) {
                  that.detailData.idCard_front_fileId = res.data.data.id;
                } else if (type === 2) {
                  that.detailData.idCard_back_fileId = res.data.data.id;
                } else if (type === 3) {
                  that.detailData.businessLicense_fileId = res.data.data.id;
                }
              },
            });
          }
          console.log(res.data);
          that.$Toast.clear();
        });
    },

    submitEdit(){
        let that = this;
        console.log(that.detailData)
        let param = {
          id:that.detailData.id,
          orderNumber:that.detailData.orderNumber,
          user_id:that.detailData.user_id,
          site_id:that.detailData.site_id,
          coupon_id:that.detailData.coupon_id,
          contactName:that.detailData.contactName,
          contactNumber:that.detailData.contactNumber,
          intermediary_company:that.detailData.intermediary_company,
          company:that.detailData.company,
          siteUse:that.detailData.siteUse,
          leaseDuration:that.detailData.leaseDuration,
          remark:that.detailData.remark,
          else_registered:that.detailData.else_registered,
          else_seal:that.detailData.else_seal,
          else_bankAccount:that.detailData.else_bankAccount,
          else_taxBureauRegistration:that.detailData.else_taxBureauRegistration,
          else_annualAudit:that.detailData.else_annualAudit,
          else_accountOpeningAppointment:that.detailData.else_accountOpeningAppointment,
          else_taxBureauDoorToDoorAppointment:that.detailData.else_taxBureauDoorToDoorAppointment,
          totalPrice:that.detailData.totalPrice,
          payablePrice:that.detailData.payablePrice,
          discountAmount:that.detailData.discountAmount,
          paymentTime:that.detailData.paymentTime,
          paymentMethod:that.detailData.paymentMethod,
          status:that.detailData.status,
          idCard:that.detailData.idCard,
          unifiedSocialCreditCode:that.detailData.unifiedSocialCreditCode,
          company_official:that.detailData.company_official,
          company_legalPerson:that.detailData.company_legalPerson,
          company_address:that.detailData.company_address,
          idCard_front_fileId:that.detailData.idCard_front_fileId,
          idCard_back_fileId:that.detailData.idCard_back_fileId,
          businessLicense_fileId:that.detailData.businessLicense_fileId,
        }

        if(!that.detailData.hasOwnProperty('idCard_front_fileId') || !param.idCard_front_fileId){
          Dialog.alert({
              title: '提示',
              message: '请先检查身份证正面照是否上传!',
            }).then(() => {
              // on close
            });
            return false;
        }
        if(!that.detailData.hasOwnProperty('idCard_back_fileId') || !param.idCard_back_fileId){
          Dialog.alert({
              title: '提示',
              message: '请先检查身份证反面照是否上传!',
            }).then(() => {
              // on close
            });
            return false;
        }
        if(!that.detailData.hasOwnProperty('businessLicense_fileId') || !param.businessLicense_fileId){
          Dialog.alert({
              title: '提示',
              message: '请先检查营业执照是否上传!',
            }).then(() => {
              // on close
            });
            return false;
        }
        that.$api
        .orderInfoUserH5UploadAPI(param)
        .then(function(res) {
          if (res.data.code === 200) {
            Dialog.alert({
              title: '提示',
              message: '修改成功!',
            }).then(() => {
              // on close
              that.$router.go(-1);
            });
          }else {
            Dialog.alert({
              title: '提示',
              message: '修改失败!',
            }).then(() => {
              // on close
            });
          }
        })
        .catch(function(err) {
          console.log("error", err);
        });
    },
  },
};

</script>
<style lang="less" scoped>
.site_lease {
  .form_feature {
    color: #646566;
    margin: 15px 10px;

    .feature_list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .van-button {
        height: 35px;
        margin-top: 15px;
        width: 100px;
        margin-right: 15px;
      }
    }

    .feature_server {
      display: flex;
      justify-content: space-between;
      font-size: 15px;
      margin-top: 15px;
      align-items: center;

      .server_btn {
        display: flex;
        justify-content: space-between;

        .van-button {
          width: 100px;
          margin-left: 15px;
        }
      }
    }
  }

  .lease_title {
    font-size: 14px;
    color: #666;
    padding: 15px 20px;
    background: #f4f3f8;
  }

  .lease_mark {
    font-size: 14px;
    color: #666;
    padding: 0px 20px;
    background: #fff;
  }

  .van-radio-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .van-button {
    height: 35px;
  }

  .lease_mark_area /deep/.van-field__value {
    height: 100px;
    background: #f4f3f8;
    padding: 10px;
    font-size: 16px;
  }

  .contract_data {
    .data_idcard {
      padding: 25px 16px;
      color: #323233;
      font-size: 15px;

      .idcard_img {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;

        .img_item {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          width: 48%;
        }

        .img_license {
          border-radius: 2px;
          background-color: rgba(0, 0, 0, 0.02);
          width: 100%;
          border: 1px solid rgba(0, 0, 0, 0.15);
          height: 150px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }

        .img_idcard {
          border-radius: 2px;
          background-color: rgba(0, 0, 0, 0.02);
          width: 45%;
          border: 1px solid rgba(0, 0, 0, 0.15);
          height: 150px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
      }
    }
  }

  /deep/ .van-field__control {
    color: #979797;
  }

  /deep/ .van-uploader__wrapper {
    width: 100% !important;
    height: 100% !important;
  }

  /deep/ .van-uploader__preview {
    width: 100% !important;
    height: 100% !important;
    margin: 0px !important;
  }

  /deep/ .van-uploader__preview-image {
    width: 100% !important;
    height: 100% !important;
  }

  /deep/ .van-uploader__input-wrapper{
    width: 100%;
    margin-top: 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/order/OrderEdit.vue